<template>
  <section class="signup-wrapper">
    <div class="signup">
      <div class="header">
        <div class="logo">
          <img
            src="@/assets/images/logo-lg.svg"
            class="unselectable mx-auto"
            alt
            width="86px"
            height="16px" 
          />
        </div>
        <p class="header-title">PASSPORT ACCOUNT</p>
        <span class="subtitle">Thanks for registering!</span>
      </div>
      <div class="content">
        <div class="icon-wrapper">
          <i class="mdi mdi-email icon"></i>
        </div>
        <p class="content-title">Please check your email</p>
        <p class="content-info">
          We sent you an email with a temporary password. Please login to set
          your own.
        </p>
        <div class="login-wrapper">
          <router-link class="login-btn"  variant="primary"
            :to="{ path: '/login', query: { email: this.user.email? this.user.email:this.user.form.user.email } }"
            >Login</router-link
          >
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("authfack", ["user"]),
  },
};
</script>

<style lang="scss" scoped>
@media (max-width: 992px){
  .logo{
    width:116px!important;
    height: 22px!important;
   img{
  width:116px!important;
  height: 22px!important;
}
}
}
.signup-wrapper {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  .signup {
    width: 491px;
    border-radius: 26px;
    background-color: #fff;
    padding: 50px 40px;
    .header {
      text-align: center;
      margin-bottom: 44px;
      .logo {
        margin-bottom: 20px;
        margin-right: auto;
        margin-left: auto;
      }
      .header-title {
        font-weight: bold;
        font-size: 20px;
        text-align: center;
        color: #000000;
        margin-bottom: 45px;
      }
      .subtitle {
        font-weight: 500;
        font-size: 14px;
        letter-spacing: 0.25px;
        color: #000000;
      }
    }
    .content {
      background: #f2f2f2;
      border-radius: 17px;
      padding: 52px 32px;
      text-align: center;

      .icon-wrapper {
        margin-bottom: 25px;
        text-align: center;
        .icon {
          color: #103f5e;
          font-size: 3.5rem;
        }
      }
      .content-title {
        font-size: 16px;
        color: #103f5e;
        font-family: "Nexa Black";
      }
      .content-info {
        font-weight: normal;
        font-size: 14px;
        letter-spacing: 0.25px;
      }
      .login-wrapper{
        width:284px;
        height:34px;
        margin:0 auto 33.86px auto ;
        padding: 7px 12px;
        border-radius: 22px;
        background-color: #103F5E;
        .login-btn {
        font-size: 16px;
        list-style: 19px;
        text-transform: uppercase;
        font-weight: bold;
        color: rgba(255, 255, 255, 0.87);
      }
      }
      
    }
  }
}
</style>
